/*
 * 进件页 / 结果页公共逻辑：推送进件、进件后跳转、贷超列表、downPageUrl 结果页等。
 * 由 entry_*.vue、registerEntry_*.vue、result_zk_suc_comn.vue 等混入使用。
 */
import * as API_Common from '@/api/common.js'
import { setCookie } from '@/utils/cookies.js'
import { fixAppFrameHref, formatAppFrameLinkUrl } from '@/utils/appFrameUrl.js'
import { stopResultRecording } from '@/utils/insuranceRecorder'
import { saveInsuranceResult } from '@/utils/insuranceResult'
import { openInsuranceFlow } from '@/utils/openInsuranceFlow.js'

/** 渠道 source → 贷超列表静态页文件名 */
const PRODUCT_LIST_HTML_BY_SOURCE = {
  renpinjiekuan: 'productListTl3.html',
  huiyihua: 'productListSjh.html',
  yangxiaomie: 'productListCchjq.html',
  sjhreview: 'productListSjh2.html',
}
const DEFAULT_PRODUCT_LIST_HTML = 'productListOrange.html'

export const entryCommon = {
  data() {
    return {
      isH5DownloadAppShow: parseInt(this.$route.query.isH5DownloadAppShow), // 是否展示 H5 下载 App
      isRedirectProductsPage: parseInt(this.$route.query.isRedirectProductsPage), // 是否走贷超：1 是 0 否（登录页带入）
      isShowTenAccount: parseInt(this.$route.query.isShowTenAccount), // 是否展示公众号
      h5JumpProduct: {}, // 贷超直跳 H5 时接口返回的推荐产品
      applyPageUrlTid: this.$route.query.applyPageUrlTid || '', // 进件页模板 id
      downPageUrlTid: this.$route.query.downPageUrlTid || '', // 下载/结果页模板 id
      incomingShow: false, // 撞库失败协议弹窗
      pendingLoopProductToast: false, // 单推换品后展示 toast
      insuranceFlowPending: false, // 保险页展示期间拦截重复进件结果分发
      isCpaProductTwo: false, // 是否是CPA产品二
      isMorePush: this.$route.query.isMorePush || this.$route.query.IsMorePush || '0', // 是否是多推
      source: this.$route.query.source || '', // 渠道
      userId: this.$route.query.userId || '', // 用户id
    }
  },
  computed: {
    remarkText() {
      if (this.isCpaProductTwo) return '产品二' + (this.productId || '')
      return '产品一;' + (this.productId || '')
    },
  },
  mounted() {
    const lastUrlCpa = sessionStorage.getItem('lastUrlCpa')
    // 下游 CPA 产品返回该页面，重新展示协议弹窗
    if (lastUrlCpa !== window.location.href) return

    sessionStorage.removeItem('lastUrlCpa')
    const lastUrlCpaApplyId = sessionStorage.getItem('lastUrlCpaApplyId')
    if (lastUrlCpaApplyId) {
      this.applyId = lastUrlCpaApplyId
      sessionStorage.removeItem('lastUrlCpaApplyId')
    }
    this.showCpaReturnAgreementPopup()
  },
  methods: {
    // ---------- 工具方法 ----------

    /** 按顺序取第一个非空值 */
    pickNonEmpty(...values) {
      for (let i = 0; i < values.length; i++) {
        const v = values[i]
        if (v != null && v !== '') return v
      }
      return ''
    },

    /** 延迟跳转；delayMs 为 0 时立即执行 */
    scheduleNavigate(fn, delayMs) {
      if (delayMs > 0) setTimeout(fn, delayMs)
      else fn()
    },

    /**
     * 拼接 downPageUrl 完整地址（登录页配置的进件成功结果页）。
     * 进件页用 form.loanAmount；result_zk_suc_comn 用 this.loanAmount / 路由 query。
     *
     * processId 这个参数是半流程的表单页才使用的参数
     */
    buildDownPageRedirectUrl(timestamp, hasPushSuccess) {
      const q = this.$route.query || {}
      const down = this.downPageUrl
      if (!down) return ''
      const loanAmount =
        (this.form && this.form.loanAmount) || this.loanAmount || q.loanAmount || q.amount || ''
      const brand = this.pickNonEmpty(this.brand, q.brand)
      const sep = String(down).includes('?') ? '&' : '?'
      const pushSuccessQuery =
        hasPushSuccess != null && hasPushSuccess !== '' ? `&hasPushSuccess=${hasPushSuccess}` : ''
      return `${down}${sep}source=${
        this.source || q.source || ''
      }&brand=${brand}&loanAmount=${loanAmount}&applyId=${this.applyId}&isRedirectProductsPage=${
        this.isRedirectProductsPage
      }&tsp=${timestamp}&apiReqType=${this.apiReqType}&isH5DownloadAppShow=${
        this.isH5DownloadAppShow
      }&isShowTenAccount=${this.isShowTenAccount}&downPageUrlTid=${this.downPageUrlTid}&processId=${
        this.processId || q.processId || ''
      }${pushSuccessQuery}`
    },

    /** 按当前渠道 source 解析贷超列表页 HTML 文件名 */
    productListHtml() {
      return PRODUCT_LIST_HTML_BY_SOURCE[this.source] || DEFAULT_PRODUCT_LIST_HTML
    },

    // ---------- 页面跳转 ----------

    /**
     * 跳转贷超列表页
     * @param {number|null} trackEvent - 埋点事件号，null 则不埋点
     * @param {number} delayMs - 延迟毫秒
     */
    goProductListPage(trackEvent, delayMs) {
      this.scheduleNavigate(() => {
        if (trackEvent) {
          if (trackEvent === 100019) {
            API_Common.handleBatchTrackBase(trackEvent, {
              remark: this.remarkText,
            })
          } else {
            API_Common.handleBatchTrackBase(trackEvent)
          }
        }
        this.navigateAway(`/${this.productListHtml()}?source=${this.source}&tsp=${Date.now()}`)
      }, delayMs)
    },

    /** 跳转兜底下载结果页 result_loan_themeTwo（埋点 100020） */
    goResultLoanThemeTwo(delayMs) {
      this.scheduleNavigate(() => {
        API_Common.handleBatchTrackBase(100020, {
          remark: this.remarkText,
        })
        this.navigateAway(
          `/result_loan_themeTwo?source=${this.source}&tsp=${Date.now()}&brand=${
            this.brand
          }&processId=${this.$route.query.processId}&isAfter=1`
        )
      }, delayMs)
    },

    /** 跳转 downPageUrl 配置的结果页（埋点由 trackEvent 指定，常用 100018） */
    goDownPageResult(delayMs, trackEvent) {
      this.scheduleNavigate(() => {
        if (trackEvent)
          API_Common.handleBatchTrackBase(trackEvent, {
            remark: this.remarkText,
          })
        const url = this.buildDownPageRedirectUrl(Date.now(), this.hasPushSuccess)
        if (url) this.navigateAway(url)
      }, delayMs)
    },

    /** 页面跳转入口：sjhjd 渠道统一走 downloadApp_jd */
    navigateAway(url) {
      url = fixAppFrameHref(url)
      console.log('navigateAway 跳转之前url:', url)
      if (this.source === 'sjhjd') {
        if (String(url).includes('/downloadApp_jd')) {
          window.location.href = url
          return
        }
        window.location.href = `/downloadApp_jd?iframeUrl=${encodeURIComponent(url)}`
        return
      }
      window.location.href = url
    },

    /**
     * 实时校验产品、记录点击后跳转三方；失败回调用于 CPA 场景继续原有兜底流程。
     * @param {Function|null} onCheckError - check 失败后的业务兜底回调
     * @param {number} showPage - 当前产品展示场景，CPA 默认使用 27
     */
    jumpAppFrameAfterLoanRecord(onCheckError, showPage = 27) {
      // 在 sessionStorage 中记录跳转 url 与 applyId，返回时恢复协议弹窗
      sessionStorage.setItem('lastUrlCpa', window.location.href)
      if (this.applyId) {
        sessionStorage.setItem('lastUrlCpaApplyId', String(this.applyId))
      }

      API_Common.buried({
        productId: this.productId,
        showPage: showPage,
      })
        .then((res) => {
          const data = res.data
          this.productId = data.productId || this.productId
          setCookie('linkUrl', data.linkUrl)
          this.loading = false
          this.navigateAway(
            '/appFrame?productId=' + this.productId + '&url=' + formatAppFrameLinkUrl(data.linkUrl)
          )
        })
        .catch((error) => {
          console.error('产品实时校验失败', error)
          this.loading = false
          if (onCheckError) {
            onCheckError(error)
          } else {
            this.$toast.fail(error.message || '获取跳转链接失败')
          }
        })
    },
    // ---------- 推送进件 ----------

    /**
     * 用户点击「同意协议 / 立即申请」后调用。 进件接口调用
     * 有 redirectUrl 直跳三方（撞库半流程会有这个逻辑判断，有这个值）；否则调 pushApply / submitPushApply2JQB，再走 afterSubmitPushApply。
     *
     */
    async submitPushApply() {
      // 匹配阶段已拿到三方地址，不再请求推送接口
      // 这个是撞库半流程的判断
      if (this.redirectUrl) {
        API_Common.statisticCallBackUrlData({
          applyId: this.applyId,
          productId: this.productId,
          redirectUrl: this.redirectUrl,
          apiReqType: this.apiReqType,
          applySource: 2,
        })
        sessionStorage.setItem('lastUrl', window.location.href)
        this.navigateAway(
          '/appFrame?productId=' +
            this.productId +
            '&url=' +
            formatAppFrameLinkUrl(this.redirectUrl)
        )
        return
      }

      // 匹配失败(0) 或 夜间量(2)：不请求推送接口，直接走 gotoNextPage 分支
      if (this.hasPushSuccess === 0 || this.hasPushSuccess === 2) {
        this.gotoNextPage(false)
        return
      }

      this.loading = true

      // 是否是CPA产品二
      if (this.isCpaProductTwo) {
        API_Common.handleBatchTrackBase(100061, { remark: `产品二id: ${this.productId}` })
        this.jumpAppFrameAfterLoanRecord(() => {
          API_Common.handleBatchTrackBase(100083)
          this.gotoNextPage(false)
        })
      } else {
        // 非CPA产品
        try {
          const apiType = Number(this.apiReqType)
          let res
          if (apiType === 1) {
            // 闪借花
            const body = {
              applyId: this.applyId,
              productId: this.productId,
              channelCode: this.source,
              processId: this.processId || this.$route.query.processId || '',
              isHalfProduct: this.isMorePush === '1' ? 1 : 0,
            }
            res = await API_Common.pushApply(body)
          } else if (apiType === 2) {
            // 吉琼宝
            const body = {
              applyId: this.jqbApplyId,
              productId: this.jqbProductId,
              channelCode: this.source,
            }
            res = await API_Common.submitPushApply2JQB(body)
          } else {
            this.loading = false
            return
          }

          await this.afterSubmitPushApply(res)
        } catch (err) {
          this.loading = false
          this.gotoNextPage(false)
        }
      }
    },

    /** pushApply / submitPushApply2JQB 返回后的跳转分发 */
    async afterSubmitPushApply(res) {
      if (this.insuranceFlowPending) return
      console.log('进件结果afterSubmitPushApply', JSON.stringify(res), this.$route.name)
      this.loading = false
      if (res.code !== 200) {
        this.gotoNextPage(false)
        return
      }

      const data = res.data || {}
      // 进件接口返回后以本次进件状态覆盖撞库状态，确保后续下载页、夜间量和贷超分流都使用最新结果。
      this.hasPushSuccess = data.hasPushSuccess
      // 保留原重定向最高优先级；即使具有保险资格，也先按进件结果跳转三方。
      if (data.hasPushSuccess === 1 && data.redirectUrl) {
        this.applyId = data.applyId
        sessionStorage.setItem('lastUrl', window.location.href)
        this.navigateAway(
          '/appFrame?productId=' +
            this.productId +
            '&url=' +
            formatAppFrameLinkUrl(data.redirectUrl)
        )
        return
      }
      // 未命中原重定向时才判断产品1保险资格；缺省或非1继续原有的后续分发。
      if (
        Number(this.apiReqType) === 1 &&
        !this.isCpaProductTwo &&
        Number(data.insuranceEligible) === 1
      ) {
        this.insuranceFlowPending = true
        try {
          // 原协议弹窗由进件页持有，先关闭并更新视图，再交接保险页，避免旧蒙层继续遮挡。
          this.incomingShow = false
          await this.$nextTick()
          const resume = await openInsuranceFlow(this, this.source, data.insuranceProductCode || '')
          if (!resume || this._isDestroyed || this._isBeingDestroyed) return
          if (resume.insuranceResult) {
            // 投保受理后直达原配置结果页，使用本次进件参数，不再换品或重新进件。
            const key = saveInsuranceResult(resume.insuranceResult)
            this.applyId = data.applyId != null ? data.applyId : this.applyId
            const configured = this.buildDownPageRedirectUrl(Date.now(), data.hasPushSuccess)
            const fallback =
              '/result_orange?source=' +
              encodeURIComponent(this.source) +
              '&applyId=' +
              encodeURIComponent(this.applyId || '') +
              '&hasPushSuccess=' +
              data.hasPushSuccess
            const target = new URL(configured || fallback, window.location.href)
            target.searchParams.set('insuranceResultKey', key)
            if (
              this.$router &&
              this.source !== 'sjhjd' &&
              target.origin === window.location.origin &&
              this.$router.match(target.pathname).matched.length
            ) {
              // 同站结果页使用路由切换，保留录制实例直到结果区块绘制完成。
              await this.$router.push(target.pathname + target.search + target.hash)
            } else {
              this.navigateAway(target.href)
            }
            return
          }
        } catch (error) {
          stopResultRecording()
          this.$toast('保险流程加载失败，请重试')
          return
        } finally {
          this.insuranceFlowPending = false
        }
      }
      // 进件失败 并且不再撞库成功协议页面
      if (data.hasPushSuccess === 0 && this.$route.name !== 'ResultZkSucComn') {
        // nextProductId 有值 说明未超过失败次数 留在当前页面并且刷新产品列表
        if (data.nextProductId) {
          this.isLoopProduct = 1
          this.productId = data.nextProductId
          this.pendingLoopProductToast = true
          this.againProduct(1)
          return
        }
        this.getProductDetailNewDate()
        return
      }
      if (data.isRedirectProductsPage === 2 && data.hasPushSuccess === 1) {
        // 进件成功，且为屏蔽城市 直接去下载页
        this.goResultLoanThemeTwo(1000)
        return
      } else if (data.hasPushSuccess && data.isRedirectLoanExcess === 0) {
        this.isRedirectProductsPage = data.isRedirectLoanExcess
      }
      this.applyId = data.applyId
      this.gotoNextPage(data.hasPushSuccess, data, this.apiReqType)
    },

    // 再次获取产品（单推失败换品）
    async againProduct(isLoopProduct) {
      let res
      try {
        res = await API_Common.secondPushProduct(
          this.source,
          this.productId,
          this.applyId,
          isLoopProduct,
          this.isMorePush === '1' ? 1 : 0
        )
      } catch (err) {
        this.loading = false
        this.pendingLoopProductToast = false
        this.gotoNextPage(false)
        return
      }

      if (res.code !== 200 || !res.data) {
        this.loading = false
        this.pendingLoopProductToast = false
        this.gotoNextPage(false)
        return
      }

      /** 如果主推产品id为空，则跳转下载页 */
      if (!res.data.mainPushProductId) {
        this.pendingLoopProductToast = false
        this.hasPushSuccess = 0
        this.loading = false

        return
      }

      this.isLoopProduct = 0
      this.hasPushSuccess = 1
      this.productId = res.data.mainPushProductId

      if (typeof this.applyCollisionPayload === 'function') {
        this.applyCollisionPayload(res.data)
      } else {
        this.openAgreementPopup()
      }

      // 换品后同步替换协议内容，确保弹窗展示当前匹配产品的协议。
      this.sendData = res.data

      if (this.pendingLoopProductToast) {
        this.pendingLoopProductToast = false
        this.showLoopProductSwitchToast()
      }

      this.loading = false
    },
    showLoopProductSwitchToast() {
      this.$toast({
        message: '已为您挑选更高额度产品，请确认协议。',
        duration: 3000,
      })
    },
    /** 半流程多推（isMorePush=1）进入页面上报 pageView */
    reportPageViewIfNeeded() {
      if (this.isMorePush === '1') {
        const processId = this.$route.query.processId
        if (!processId) return
        API_Common.pageView(processId, this.source)
      }
    },

    /**
     * 根据推送/匹配结果跳转下一页（核心路由表）。
     *
     * @param {*} hasPushSuccess - 本次 pushApply 是否成功（入参，与 this.hasPushSuccess 可能不同）
     * @param {object} resData - 推送接口返回的 data
     * @param {number} apiReqType - 1 闪借花 2 吉琼宝
     *
     * this.hasPushSuccess：进件匹配结果，0 失败 1 成功 2 夜间量
     * this.isRedirectProductsPage：是否走贷超，1 是 0 否
     * this.loanSuperPageRedirectRule：贷超规则 1 当前页弹窗推贷超 2 跳贷超列表 3 直跳下游 H5
     * this.downPageUrl：登录配置的进件成功结果页地址
     */

    async gotoNextPage(hasPushSuccess, resData = {}, apiReqType) {
      // 半流程：优先获取三方下载链接，成功则直接跳转并终止后续分支
      if (this.$route.query.processId) {
        try {
          const res = await API_Common.getHalfDownloadUrl(
            this.source,
            this.processId,
            this.h5ChannelCode
          )
          console.log('获取三方链接', JSON.stringify(res))
          if (res.code === 200 && res.data && res.data.url) {
            API_Common.handleBatchTrackBase(100058, { remark: res.data.url })
            this.navigateAway(res.data.url)
            return
          }
        } catch (e) {
          console.error('获取三方链接失败', e)
        }
      }

      // --- pushApply 成功：优先三方 redirectUrl，否则 downPageUrl 结果页 ---
      // && (resData.redirectUrl || this.downPageUrl) 这个判断逻辑及兼容 甜瓜 因为没有走登录页而且撞库成功接口没返回 downPageUrl 字段，
      if (hasPushSuccess && (resData.redirectUrl || this.downPageUrl)) {
        if (apiReqType == 1 && resData.redirectUrl) {
          sessionStorage.setItem('lastUrl', window.location.href)
          this.navigateAway(
            '/appFrame?productId=' +
              this.productId +
              '&url=' +
              formatAppFrameLinkUrl(resData.redirectUrl)
          )
          return
        }
        API_Common.handleBatchTrackBase(100018, {
          remark: this.remarkText,
        })
        const url = this.buildDownPageRedirectUrl(Date.now(), hasPushSuccess)
        if (url) this.navigateAway(url)
        return
      }

      // --- 匹配失败 this.hasPushSuccess === 0 ---
      if (this.hasPushSuccess === 0) {
        if (this.isRedirectProductsPage === 1) {
          this.goProductListPage(100019, 1000)
        } else {
          this.goResultLoanThemeTwo(1000)
        }
        return
      }

      // --- 夜间量 this.hasPushSuccess === 2：downPageUrl 结果页 ---
      if (this.hasPushSuccess == 2) {
        this.goDownPageResult(1000, 100018)
        return
      }

      // --- 贷超流程：按 loanSuperPageRedirectRule 分支 ---
      const isLoanExcess = this.isRedirectProductsPage == 1
      const rule = this.loanSuperPageRedirectRule // 贷超规则 1 当前页弹窗推贷超 2 跳贷超列表 3 直跳下游 H5

      if (isLoanExcess && rule == 2) {
        // 跳贷超列表页
        this.goProductListPage(100019, 1000)
        return
      }
      if (isLoanExcess && rule == 3) {
        // 直跳下游 H5（有推荐产品则点产品逻辑，无则列表页）
        API_Common.handleBatchTrackBase(100019, {
          remark: this.remarkText,
        })
        this.h5CpaProductRecommendRequest()
        return
      }
      if (isLoanExcess && rule == 1) {
        // 当前页弹窗推贷超
        API_Common.handleBatchTrackBase(100019, {
          remark: this.remarkText,
        })
        this.showProductsPop = true
        this.getProductList()
        return
      }

      // 其它：兜底下载结果页
      this.goResultLoanThemeTwo(1000)
    },

    /**
     * h5ApplyV2 / submitAnEntry 成功后。
     * hasPushSuccess===1 时直进 result_zk_suc_comn；撞库失败展示 Agreement 弹窗
     */
    async afterSubmitAnEntrySuccess(res) {
      console.log('afterSubmitAnEntrySuccess 撞库信息返回:', JSON.stringify(res))
      if (res && res.data && res.data.hasPushSuccess == 1) {
        this.reportPageViewIfNeeded()
        if (this.isMorePush === '1' && this.productId) {
          API_Common.scheduleDelayPushApply({
            applyId: this.applyId,
            productId: this.productId,
            channelCode: this.source,
          }).catch(() => {})
        }
      } else {
        const processId = this.processId || this.$route.query.processId
        if (processId) {
          API_Common.pageView(processId, this.source).catch(() => {})
        } else {
          // 协议弹窗由用户主动确认，空详情时留在当前页等待确认，避免提前跳转。
          await this.getProductDetailNewDate(false)
        }
      }

      this.openAgreementPopup()
    },
    openAgreementPopup() {
      this.incomingShow = true
      this.companys = ''
    },
    /** 从 CPA 三方页返回进件页时，拉取产品二协议并展示弹窗 */
    async showCpaReturnAgreementPopup() {
      // 返回页仍需完整展示协议弹窗，空详情时不在此处提前跳转
      await this.getProductDetailNewDate(false)
      this.openAgreementPopup()
    },
    /** 拉取 CPA 产品二详情；非弹窗调用可在空详情时沿用原有兜底跳转 */
    async getProductDetailNewDate(navigateOnEmpty = true) {
      const res = await API_Common.pushCpaProductDetail(Number(this.applyId))
      console.log('尾部cpa产品详情:', JSON.stringify(res))
      if (res.code === 200 && res.data && res.data.productId) {
        API_Common.handleBatchTrackBase(100060, { remark: `产品二id: ${res.data.productId}` })
        this.isCpaProductTwo = true
        this.hasPushSuccess = 1
        this.productId = res.data.productId
        if (res.data.agreements) {
          res.data.agreements.defaultAgreements = []
        }

        // CPA 详情可能没有撞库状态；已取得有效产品时，统一让各进件页的协议弹窗展示匹配卡片。
        this.sendData = { ...res.data, hasPushSuccess: 1 }
      } else if (navigateOnEmpty) {
        // 无后续弹窗承接时立即进入既有路由分发，避免流程停留在当前页
        this.gotoNextPage(false)
      }
    },

    handleFormPageTrack(eventType) {
      if (this.userId) {
        API_Common.handleBatchTrackBase(eventType, { remark: this.userId })
      } else {
        API_Common.handleBatchTrackBase(eventType)
      }
    },

    handleTl5ThemeOneAgreementPopupOpened() {
      this.handleFormPageTrack(100034)
    },
    handleTl5ThemeOneAgreementKnowClicked() {
      this.handleFormPageTrack(100035)
    },
    handleGoOn() {
      if (this.loading) return

      const channelCode = this.source || (this.form && this.form.channelNo) || ''
      const processId = this.processId || this.$route.query.processId
      if (!processId) {
        this.submitPushApply()
        return
      }
      // 半流程的逻辑
      API_Common.getHalfDownloadUrl(channelCode, processId)
        .then((res) => {
          if (res.code === 200 && res.data.url) {
            API_Common.handleBatchTrackBase(100058, { remark: res.data.url })
            this.navigateAway(res.data.url)
          } else {
            this.submitPushApply()
          }
        })
        .catch(() => this.submitPushApply())
    },

    /** 贷超规则=1：拉取弹窗内展示的产品列表 */
    getProductList() {
      API_Common.h5CpaProductAllPageList({
        channelCode: this.source,
        pageNum: 1,
        pageSize: 2,
        showPage: 22,
      }).then((res) => {
        if (res.code == 200 && res.data.productPageVO.list) {
          this.productsPopData = res.data.productPageVO.list
        } else {
          this.$toast.fail('获取产品列表失败')
        }
      })
    },

    /** 贷超规则=3：推荐接口，有产品则直跳，无产品则贷超列表（500ms 延迟） */
    h5CpaProductRecommendRequest() {
      API_Common.h5CpaProductRecommendRequest({
        showPage: 22,
        channelCode: this.source,
      }).then((res) => {
        if (res.code !== 200) {
          this.$toast.fail(res.msg)
          return
        }
        if (res.data && res.data.recommendProduct) {
          this.h5JumpProduct = res.data.recommendProduct
          this.handleProductClick(this.h5JumpProduct, 22)
          return
        }
        this.goProductListPage(null, 500)
      })
    },

    /**
     * 贷超产品点击：联登/半流程进详情，否则埋点后跳三方 H5。
     */
    handleProductClick(obj, showPage) {
      if (obj.checkMobileStatus != 0) {
        API_Common.handleBatchTrackBase(100040)
        this.navigateAway(
          `/productDetail?productId=${obj.productId}&showPage=${showPage}&source=${this.source}`
        )
        return
      }
      API_Common.handleBatchTrackBase(100039)
      API_Common.buried({
        productId: obj.productId,
        showPage,
      })
        .then((res) => {
          const productId = res.data.productId || obj.productId
          this.$toast({
            message: '将跳转三方页面',
            duration: 3000,
          })
          setTimeout(() => {
            sessionStorage.setItem('lastUrl', window.location.href)
            this.navigateAway(
              '/appFrame?productId=' + productId + '&url=' + formatAppFrameLinkUrl(res.data.linkUrl)
            )
          }, 3000)
        })
        .catch((error) => {
          console.error('产品实时校验失败', error)
          this.$toast.fail(error.message || '获取跳转链接失败')
        })
    },

    /** 进件匹配接口异常时的统一提示与留痕 */
    requestErrorHandle(error, logData) {
      delete logData.applyId
      logData.errorType = 2
      logData.errorMsg = error.toString()
      this.$toast({
        message: '当前申请人数较多，请重新提交获取结果',
        duration: 3000,
      })
      setTimeout(() => {
        this.loading = false
        API_Common.addMatchStayLog(logData)
      }, 3000)
    },
  },
}
